
class CartNotification extends HTMLElement {
  constructor() {
    
    super();

    this.cartEventQty = 0;
    this.cartEventKey = 0;

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    document.getElementsByTagName('sticky-header')[0].addEventListener('click', e => {
      if (e.target.classList.contains('header__icon--cart')) {
        this.open();
        e.preventDefault()
      }  
    });  
  
    document.querySelector('.mini-cart').querySelectorAll('.quantity__input').forEach((cartQty) => {
      cartQty.value = cartQty.getAttribute('data-val'); 
    });
    document.getElementById('cart-notification').addEventListener('change', e => {  
      if (e.target.getAttribute('type') == 'number') {
        const itemKey = e.target.getAttribute('data-key');
        const itemValue = e.target.value;
        this.changeItem(itemKey, itemValue)
      }  
    });

//     document.querySelector('.mini-cart').querySelectorAll('.qqwe').forEach((element) => {
//         element.addEventListener('click', function (e) {
//           console.log("YEY");
//         });
//       });
    function mini_cart(){
      $(".pet-api-mini").css("display","block");
      var acc = document.getElementsByClassName("pet-name-mini");
      var i;
      var li_count = $(".pet-name-mini-cart li").length;
      for (i = 0; i < li_count; i++) {
        acc[i].addEventListener("click", function() {
          console.log($(this).parent().prev());
          $(this).parent().prev().text($(this).text());
          $(this).parent().prev().prev().val($(this).text())
          $(this).parent().prev().attr("data-value",$(this).text());
          
          
          var line_name = $(this).parent().prev().data("value");
          var line_id = $(this).parent().prev().data("line");
		  var line_product_id = $(this).parent().prev().data("id");
          $(".name-"+line_product_id+"-"+line_id+"").attr("data-value",$(this).text());
          $(".petid-"+line_product_id+"-"+line_id+"").attr("data-value",$(this).data("value"));
          console.log("NAME: " + line_name+ "- ID: "+ line_product_id +"" );
          console.log(".petid-"+line_product_id+"-"+line_id+"");
          
        });
      }
    }
    function clickTest(){
//         console.log("YEY1");
      $.ajax({
        type: "GET",
        url: "https://scriptly.brdsites.com/api/v1/customer/"+window.customerId+"/pets",
        dataType: "json",
        success: function(data) {
//           console.log(data);
          $data = JSON.stringify(data);
          $(".pet-name-mini-cart").empty();
          
          $(".pet-name-mini-cart").append('<li class="add-pet-li"><a href="/pages/pet-registration">+ Add new pet</a></li>');
          for(var a = 0; a < data.length; a++)
          {
            $(".pet-name-mini-cart").prepend("<li class='pet-name-mini' data-value='"+ data[a]["id"] +"'>"+ data[a]["name"] +"</li>");
          }
          setTimeout(mini_cart, 1000)  
        },
        error: function(data) {
          console.log(data);
        }
      });
    }
    
    document.body.addEventListener('mouseover', function ( event ) {
      if( event.target.getAttribute('class').split(' ').indexOf('qqwe') >= 0 ) {
        clickTest();
      };
    } );

//     $(".prescription-on-file-click").on('click',function(){
//       console.log(this);
//       test_data_f = $(this).data("value");
//       line_id_f = $(this).data("line");
//       console.log(".name-"+test_data_f+"-"+line_id_f+"")
//       console.log(".petid-"+test_data_f+"-"+line_id_f+"")
//       $(".mini-"+test_data_f+"-"+line_id_f+"").text("Prescription on File");


//       pet_name_f = $(".name-"+test_data_f+"-"+line_id_f+"").data("value");
//       peti_id_f = $(".petid-"+test_data_f+"-"+line_id_f+"").data("value");
//       $.ajax({
//         url: "/cart/change.js",
//         type: "POST",
//         data: '{"line": "'+line_id_f+'", "properties":{ "PetName": "'+pet_name_f+'", "PetID": "'+peti_id_f+'","Prescription": "Prescription on File"} }', 
//         contentType: "application/json",
//         dataType: 'json'
//       });
      
//     });


    document.getElementById('cart-notification').addEventListener('click', e => {

      if (e.target.classList.contains('cart-notification__close')) {
        this.close()
      }  
      if (e.target.getAttribute('name') == 'plus' || e.target.getAttribute('name') == 'minus') {
        let qtyInput = e.target.closest('div.quantity-input').querySelector('input.quantity__input');
        let qtyKey = qtyInput.getAttribute('data-key');
        let qtyInputVal = parseInt(qtyInput.value);
        
        if (e.target.getAttribute('name') == 'plus') {
          qtyInput.value = qtyInputVal + 1;
        } else if (e.target.getAttribute('name') == 'minus') {
          if (qtyInputVal != 0) {
            qtyInput.value = qtyInputVal - 1;
          }   
        }
        qtyInputVal = parseInt(qtyInput.value);
        this.open();
        let changeItem = this.changeItem(qtyKey, qtyInputVal);

        this.cartEventKey = qtyKey;
        this.cartEventQty = qtyInputVal;

      }
      if (e.target.getAttribute('name') == 'remove') {
        let qtyInput = e.target.closest('.cart-item').querySelector('input.quantity__input');
        let qtyKey = qtyInput.getAttribute('data-key');
        this.cartEventKey = qtyKey;
        this.cartEventQty = 0;

        this.open();
        this.changeItem(qtyKey, 0);
      }

      if (e.target.getAttribute('name') == 'prescription-on-file') {
//         this.notification.classList.add("loading");
        console.log(this);
        var test_data_f = 0;
        var line_id_f = 0;
        var pet_name_f = "";
        var peti_id_f ="";
        var petInfo = e.target.closest('.cart-item').querySelector('.prescription-on-file-click');
        test_data_f = petInfo.getAttribute('data-value');
        line_id_f = petInfo.getAttribute('data-line');
        console.log(".name-"+test_data_f+"-"+line_id_f+"")
        console.log(".petid-"+test_data_f+"-"+line_id_f+"")
        $(".mini-"+test_data_f+"-"+line_id_f+"").text("Prescription on File");


        pet_name_f = $(".name-"+test_data_f+"-"+line_id_f+"").data("value");
        peti_id_f = $(".petid-"+test_data_f+"-"+line_id_f+"").data("value");
        
        $.ajax({
          url: "/cart/change.js",
          type: "POST",
          data: '{"line": "'+line_id_f+'", "properties":{ "PetName": "'+pet_name_f+'", "PetID": "'+peti_id_f+'","Prescription": "Prescription on File"} }', 
          contentType: "application/json",
          dataType: 'json',
          success: function(data){
//             this.notification.classList.remove("loading")
            console.log(data);
            fetch('/cart?view=mini')
            .then((response) => response.text())
            .then((html) =>{
              document.querySelector('.mini-cart-content').innerHTML = html;
//               let cartCount = document.querySelector('.mini-count').textContent;

//               document.querySelectorAll('.cart-count-bubble').forEach((cartBubble) => {
//                 cartBubble.innerHTML = cartCount; 


//               });
              document.querySelector('.mini-cart').querySelectorAll('.quantity__input').forEach((cartQty) => {
                cartQty.value = cartQty.getAttribute('data-val'); 
              });


              

              let cartEventQtyCurrent =  document.querySelector('input[data-key="'+this.cartEventKey+'"]').value;


              if (this.cartEventQty != cartEventQtyCurrent) {
                //error qty
                document.querySelector('input[data-key="'+this.cartEventKey+'"]').closest('.cart-info').querySelector('.cart-item__error').style.display = "flex";
                document.querySelector('input[data-key="'+this.cartEventKey+'"]').closest('.cart-info').querySelector('.cart-item__error-text').innerHTML = window.cartStrings.quantityError.replace('[quantity]', cartEventQtyCurrent);
              }
            })
//             this.notification.classList.remove("loading")
          }
        });
      
      } 
      if (e.target.getAttribute('name') == 'continue_shopping') {
        this.close();
      }
      
    });
    
    
  }

  changeItem(itemKey, itemValue) {
    this.notification.classList.add("loading");
    fetch(`/cart/change?id=${itemKey}&quantity=${itemValue}`, {
        method: 'post',
      })
      .then((response) => {
        this.notification.classList.remove("loading")
        this.fetchRenderItem('change')
        $.getJSON('/cart.js', function(data){
         console.log(data);
         $(".cart_current_qty").text(data.item_count);
        });
      })
      .catch((err) => console.warn('Something went wrong.', err))
  }

  open() {
    this.notification.classList.add('active');
    
    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });
    document.body.addEventListener('click', this.onBodyClick);
	
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);
    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    
    this.fetchRenderItem()
    this.open();
    

  }
  fetchRenderItem(eventTrigger) {
    let  eventTriggerVar = eventTrigger
    fetch('/cart?view=mini')
      .then((response) => response.text())
      .then((html) =>{
        document.querySelector('.mini-cart-content').innerHTML = html;
        let cartCount = document.querySelector('.mini-count').textContent;

        document.querySelectorAll('.cart-count-bubble').forEach((cartBubble) => {
          cartBubble.innerHTML = cartCount; 
        });
        
        document.querySelector('.mini-cart').querySelectorAll('.quantity__input').forEach((cartQty) => {
          cartQty.value = cartQty.getAttribute('data-val'); 
        });
      
 
        this.notification.classList.remove("loading")
        if (eventTriggerVar == 'change') {

          let cartEventQtyCurrent =  document.querySelector('input[data-key="'+this.cartEventKey+'"]').value;
          
          
          if (this.cartEventQty != cartEventQtyCurrent) {
            //error qty
            document.querySelector('input[data-key="'+this.cartEventKey+'"]').closest('.cart-info').querySelector('.cart-item__error').style.display = "flex";
            document.querySelector('input[data-key="'+this.cartEventKey+'"]').closest('.cart-info').querySelector('.cart-item__error-text').innerHTML = window.cartStrings.quantityError.replace('[quantity]', cartEventQtyCurrent);
          }

        }
      })
      .catch((err) => console.warn('Something went wrong.', err))
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `#cart-notification-product-${this.productId}`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick({ target }) {    
    if (target !== this.notification && !target.closest('cart-notification') && target.id != 'cart-icon-bubble') {
      const disclosure = target.closest('details-disclosure');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.get('cart-notification') || customElements.define('cart-notification', CartNotification); // eslint-disable-line

